import jsPDF from "jspdf";
import "jspdf-autotable";

export function downloadAsPDF(title, fileName) {
  const doc = new jsPDF();
  const tables = document.querySelectorAll("table");
  let yOffset = 10;

  const currentDate = new Date().toLocaleDateString();
  const currentTime = new Date().toLocaleTimeString();

  tables.forEach((table, index) => {
    const tableData = [];
   
    const containerDiv = table.parentElement.parentElement;
    const tableNameElement = containerDiv.previousElementSibling;
    const tableName = tableNameElement ? tableNameElement.textContent : "";

    //console.log("Captured Table Name:", tableName);

    // const tableNameElement = table.previousElementSibling;
    // const tableName = tableNameElement ? tableNameElement.textContent : "";

    table.querySelectorAll("tr").forEach((row) => {
      const rowData = [];

      row.querySelectorAll("th, td").forEach((cell) => {
        const selectField = cell.querySelector("select");
        const inputField = cell.querySelector("input");

        if (selectField) {
          const selectedOption =
            selectField.options[selectField.selectedIndex].text;
          rowData.push(selectedOption);
        } else if (inputField) {
          rowData.push(inputField.value);
        } else {
          rowData.push(cell.innerText);
        }
      });
      tableData.push(rowData);
    });

    if (index !== 0) {
      doc.addPage();
      yOffset = 10; // Reset the y-offset for each new page
    }

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(title, 10, yOffset);
    yOffset += 10; // Increase the y-offset for the table content
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(tableName, 10, yOffset);
    yOffset += 10; // Increase the y-offset for the table content

    doc.autoTable({
      head: [tableData[0]],
      body: tableData.slice(1),
      startY: yOffset,
    });

    yOffset = doc.autoTable.previous.finalY + 10; // Update the y-offset for the next table
  });

  // Add footer with current date and time
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setFont("helvetica", "italic");
    doc.text(
      `Generated on ${currentDate} ${currentTime}`,
      doc.internal.pageSize.getWidth() - 10,
      doc.internal.pageSize.getHeight() - 10,
      {
        align: "right",
      }
    );

    // Add separator line
    doc.setDrawColor(200, 200, 200); // Set the color for the separator line
    doc.setLineWidth(0.5); // Set the line width
    doc.line(
      10,
      doc.internal.pageSize.getHeight() - 15,
      doc.internal.pageSize.getWidth() - 10,
      doc.internal.pageSize.getHeight() - 15
    ); // Draw the line
  }

  doc.save(fileName);
}
